// extracted by mini-css-extract-plugin
module.exports = {"wrap":"grouplisteditor_wrap__2NMNU"};